document.addEventListener('click', async event => {
  const gridButton = event.target.closest(
    '[class*="ai-product-grid-button-"][data-variant-id]'
  );

  const bundleButton = event.target.closest(
    '[class*="ai-product-bundle-button-"]'
  );

  const featuredButton = event.target.closest(
    '[class*="ai-featured-products__button-"][type="submit"]'
  );

  if (!gridButton && !bundleButton && !featuredButton) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const button = gridButton || bundleButton || featuredButton;
  const originalText = button.textContent.trim();

  let lines = [];

  if (gridButton) {
    window.aiCartEventTarget =
      gridButton.closest('[class*="ai-product-grid-"]') ||
      gridButton;

    lines = [{
      merchandiseId:
        `gid://shopify/ProductVariant/${gridButton.dataset.variantId}`,
      quantity: 1
    }];
  }

  if (bundleButton) {
    let bundle = bundleButton.parentElement;

    while (
      bundle &&
      !bundle.tagName.toLowerCase().startsWith('product-bundle-')
    ) {
      bundle = bundle.parentElement;
    }

    if (!bundle) {
      console.error('Product bundle container not found');
      return;
    }

    window.aiCartEventTarget = bundle;

    lines = Array.from(
      bundle.querySelectorAll(
        'input[type="checkbox"][data-variant-id]:checked'
      )
    )
      .filter(checkbox =>
        checkbox.dataset.available === 'true' &&
        checkbox.dataset.variantId
      )
      .map(checkbox => ({
        merchandiseId:
          `gid://shopify/ProductVariant/${checkbox.dataset.variantId}`,
        quantity: 1
      }));

    if (!lines.length) return;
  }

  if (featuredButton) {
    const form = featuredButton.closest('form[action="/cart/add"]');
    const variantId = form?.querySelector('input[name="id"]')?.value;

    if (!variantId) {
      console.error('Featured product variant ID missing');
      return;
    }

    window.aiCartEventTarget =
      featuredButton.closest(
        '[class*="ai-featured-products__card-"]'
      ) || featuredButton;

    lines = [{
      merchandiseId:
        `gid://shopify/ProductVariant/${variantId}`,
      quantity: 1
    }];
  }

  button.textContent = 'Adding...';
  button.disabled = true;

  try {
    const result = await Shopify.actions.updateCart(
      { lines },
      {
        event: {
          context: 'product',
          detail: {
            source: bundleButton
              ? 'product-bundle'
              : featuredButton
                ? 'featured-products'
                : 'ai-product-grid'
          }
        }
      }
    );

    if (result?.userErrors?.length) {
  throw new Error(result.userErrors[0].message);
}

button.textContent = 'Added!';

await new Promise(resolve => setTimeout(resolve, 150));

} catch (error) {
  console.error('AI cart error:', error);
  button.textContent = 'Error';
} finally {
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      window.aiCartEventTarget = null;
    }, 2000);
  }
}, true);